import { render, staticRenderFns } from "./TakbisTalepEvrakForm.vue?vue&type=template&id=72883162"
import script from "./TakbisTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./TakbisTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports